module.exports = __webpack_public_path__ + "media/images/OPL 9-ec3cef95ad30f3ab612736c9ab8bca01.png";